import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function postPullTime(data) {
    const options = {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios
        .post(`${url}/track/time_pull`, data, options)
        .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
                let errorInfo = '';
                for (const [key, value] of Object.entries(res.data)) {
                    errorInfo += `<br> ${key}: ${value} <br>`;
                }
                errorInfo += `<br> API LINK: ${url}/track/time_pull <br>`;
                throw new Error(errorInfo);
            }
            return res.data;
        })
        .catch((err) => {
            throw new Error(err.stack);
        });
}

function postUpdatePullTime(data) {
    const options = {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios
        .post(`${url}/track/time_pull_update`, data, options)
        .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
                let errorInfo = '';
                for (const [key, value] of Object.entries(res.data)) {
                    errorInfo += `<br> ${key}: ${value} <br>`;
                }
                errorInfo += `<br> API LINK: ${url}/track/time_pull_update <br>`;
                throw new Error(errorInfo);
            }
            return res.data;
        })
        .catch((err) => {
            throw new Error(err.stack);
        });
}

function postUpdateAccount(data) {
    const options = {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios
        .post(`${url}/track/update_account`, data, options)
        .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
                let errorInfo = '';
                for (const [key, value] of Object.entries(res.data)) {
                    errorInfo += `<br> ${key}: ${value} <br>`;
                }
                errorInfo += `<br> API LINK: ${url}/track/update_account <br>`;
                throw new Error(errorInfo);
            }
            return res.data;
        })
        .catch((err) => {
            throw new Error(err.stack);
        });
}

function postProductExport(data) {
    const options = {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios
        .post(`${url}/track/products_exports`, data, options)
        .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
                let errorInfo = '';
                for (const [key, value] of Object.entries(res.data)) {
                    errorInfo += `<br> ${key}: ${value} <br>`;
                }
                errorInfo += `<br> API LINK: ${url}/track/products_exports <br>`;
                throw new Error(errorInfo);
            }
            return res.data;
        })
        .catch((err) => {
            throw new Error(err.stack);
        });
}

export default {
    postPullTime,
    postUpdatePullTime,
    postUpdateAccount,
    postProductExport,
};
